import { Box, Button, Divider, Fade, Paper, Typography } from '@mui/material';

import { Home } from '@mui/icons-material';
import { useNavigate } from 'react-router';

import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';

import MotorcadeLanderBanner from '@acorn-portal/shared/src/components/banner/MotorcadeLanderBanner';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { isBillingBankAccountPaymentMethod } from '@acorn-portal/shared/src/utils/payment-method-type-guard';

const ChangeBankSuccess = () => {
	const navigate = useNavigate();

	const managedPaymentsDetails = useAppSelector((redux) => redux.managedPayments);

	const { currentBillingTerm } = managedPaymentsDetails;

	const paymentMethod = currentBillingTerm?.currentPaymentMethod;

	let sortCode: string | undefined;
	let accountNumber: string | undefined;

	if (paymentMethod && isBillingBankAccountPaymentMethod(paymentMethod)) {
		sortCode = paymentMethod.sortCode;
		accountNumber = paymentMethod.accountNumber;
	}

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<Box>
						<MotorcadeLanderBanner text=' Your change has been successful!' />
						<Box
							sx={{
								margin: 2,
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'column',
							}}
						>
							<Box sx={{ maxWidth: 700, width: '100%' }}>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'start',
										p: 2,
										borderRadius: 2,
										backgroundColor: green[50],
										my: 2,
									}}
								>
									<CheckCircleIcon sx={{ color: green[500], marginRight: 1, fontSize: '32px' }} />
									<Typography
										sx={{
											fontWeight: 400,
											fontSize: '18px',
											color: green[500],
										}}
									>
										Your change to your billing information has been updated.
									</Typography>
								</Box>
								<Typography variant='h5' color='secondary' sx={{ marginBottom: 3, fontWeight: 'bold' }}>
									New Bank Details
								</Typography>

								<Typography
									sx={{
										marginBottom: 2,
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<Typography
										sx={{
											'& a': {
												overflowWrap: 'break-word',
											},
											width: '100%',
										}}
									>
										<>
											<Box pb={'10px'}>
												<Typography>
													<b>Account Number:</b> {accountNumber}
												</Typography>
											</Box>
											<Divider />
											<Box pt={'10px'}>
												<Typography>
													{' '}
													<b>Sort Code:</b> {sortCode}
												</Typography>
											</Box>
										</>
									</Typography>
								</Typography>
							</Box>
						</Box>
						<Divider />
						<Typography sx={{ margin: 'auto', textAlign: 'center', p: 2 }}>
							Please return to the Policy Screen to see your updated policy documents. It is important you take the time
							to carefully read this information.
						</Typography>
					</Box>
					<Box
						sx={{
							padding: 3,
							textAlign: 'center',
							maxWidth: 400,
							margin: 'auto',
						}}
					>
						<Button
							startIcon={<Home />}
							size='large'
							variant='contained'
							onClick={() => {
								navigate(ROUTE_PATHS.home);
								return null;
							}}
						>
							Return to Policy Screen
						</Button>
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default ChangeBankSuccess;
